<div :class="'button-container ' + type">
    <div :class="'button ' + type" v-bind:class="returnCssClass()" @click="$emit('click', $event.target.value)">
        <i :class="'material-icons input__icon ' + type">{{icon}}</i>
        <span :class="'label ' + type">{{ label }}</span>
    </div>
    <!-- <Button :label="label" @click="$emit('click', $event.target.value)" 
    v-bind:class="returnCssClass()" :icon="icon" /> -->
</div>
